import React from "react";
import { Async } from "react-async";
import { client } from "../defs";
import { SearchResultsTiles } from "./SearchResultsTiles";

interface SearchQuery {
  q: string;
  page?: number;
  filters: any;
}

export interface SearchResultsType {
  assets: {
    assets: any[];
    total: number;
  };
  records: {
    records: any[];
    total: number;
  };
}

const parseFilters = (filters: any) => {
  console.log("parsing filters", filters);
  let parsedFilters: { search_fields: string[] } = {
    search_fields: [],
  };
  if (filters) {
    for (const key in filters) {
      if (key.startsWith("searchIn_") && filters[key]) {
        parsedFilters.search_fields.push(key.split("_")[1]);
      }
    }
  }

  if (parsedFilters.search_fields.length === 0) {
    parsedFilters.search_fields = ["name", "author", "path", "tags"];
  }
  return parsedFilters;
};

const search = async ({
  q,
  page,
  filters,
}: SearchQuery): Promise<SearchResultsType> => {
  const parsedFilters = parseFilters(filters);

  console.log("searching", q, page, parsedFilters);

  const response = await client.get(`/api/v1/search`, {
    params: {
      q: encodeURIComponent(q),
      types: "records",
      count: 50,
      offset: page ? (page - 1) * 50 : 0,
      search_fields: parsedFilters.search_fields,
      sort_by_fields: [
        "created",
        "modified",
        "firstindexed",
        "lastindexed",
        "name",
      ],
      sort_by_types: ["desc", "desc", "desc", "desc", "asc"],
    },
  });
  if (response.status !== 200) {
    throw new Error("Failed to fetch search results");
  }
  return response.data as SearchResultsType;
};

function SearchResultsRaw({
  searchText,
  currentPage,
  filters,
  setCurrentPage,
  setTotalPages,
  setSelectedRecord,
}: {
  searchText: string;
  currentPage: number;
  filters: any;
  setCurrentPage: (page: number) => void;
  setTotalPages: (total: number) => void;
  setSelectedRecord: (record: any) => void;
}) {
  const previousQuery = React.useRef("");

  return (
    <Async
      promiseFn={async () =>
        search({ q: searchText, page: currentPage, filters: filters })
      }>
      <Async.Loading>Loading...</Async.Loading>
      <Async.Fulfilled>
        {(data: any) => {
          if (previousQuery.current !== searchText) {
            setCurrentPage(1);
            previousQuery.current = searchText;
          }
          setTotalPages(Math.ceil(data.records.total / 50));
          return (
            <SearchResultsTiles
              records={data}
              setSelectedRecord={setSelectedRecord}
            />
          );
        }}
      </Async.Fulfilled>
      <Async.Rejected>
        {(error) => <div style={{ color: "red" }}>{error.message}</div>}
      </Async.Rejected>
    </Async>
  );
}

export const SearchResults = React.memo(SearchResultsRaw);